import React from "react";
import Proptypes from "prop-types";
import styled from "styled-components";
import { compose, flexbox, layout } from "styled-system";
import {
  TabView as PRTabView,
  TabPanel as PRTabPanel,
} from "primereact/tabview";
import { breakpoints } from "@utils/breakpoints";

const { tabletLandscape } = breakpoints;

const breakpoint = {
  mobile: `(max-width: ${tabletLandscape}px)`,
};
const StyledTabView = styled(PRTabView)`
  ${compose(layout, flexbox)};
  background: var(--transparent);

  &.bottom-tab-menu {
    .p-tabview-nav-container {
      i.icon {
        font-size: var(--fs-h3);
        display: flex;
        justify-content: center;
      }
      .p-tabview-title {
        font-size: var(--fs-mini) !important;
      }
    }
  }
  .p-tabview-nav-container {
    background-color: ${({ isBottomMenu }) =>
      isBottomMenu ? "var(--primary)" : "var(--transparent)"};
    order: 2;
  }
  .p-tabview-panels {
    order: 1;
    padding: 0;
    background: var(--transparent);
    padding-top: var(--lg-spacing);

    .p-tabview-nav-container {
      background: var(--transparent);
      ul {
        li {
          .p-tabview-title {
            font-size: var(--fs-base) !important;
            font-weight: var(--semibold-weight) !important;
          }
        }
      }
    }

    .p-tabview-nav {
      display: flex !important;
      li {
        padding: 0;

        &.p-tabview-selected {
          background: none;
          border-bottom: none;

          .p-tabview-nav-link {
            border-bottom: 4px solid var(--primary);
          }
        }
      }
    }
  }
  .p-tabview-nav {
    background: var(--transparent);
    border-bottom: 1px solid var(--border-line);
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap !important;
    display: ${({ isBottomMenu }) =>
      isBottomMenu ? "grid !important" : "flex !important"};
    grid-template-columns: 1fr 1fr 1fr 1fr;
    li {
      padding: ${({ isBottomMenu }) =>
        isBottomMenu ? "3px var(--regular-spacing)" : "0"};
      &.p-tabview-selected {
        border-bottom: ${({ isBottomMenu }) =>
          isBottomMenu ? "4px solid var(--text)" : "none"};
        background: ${({ isBottomMenu }) =>
          isBottomMenu ? "var(--primary-hover)" : "none"};
      }
      outline: none;
      .p-tabview-nav-link {
        background: var(--transparent);
        border: none;
        color: var(--text);
        font-size: var(--fs-base);
        font-weight: var(--bold-weight);
        line-height: var(--lh-h6);
        padding: var(--regular-spacing) 0 0 0;
        text-align: ${({ isBottomMenu }) =>
          isBottomMenu ? "center" : "inherit"};
        display: ${({ isBottomMenu }) => (isBottomMenu ? "grid" : "block")};

        i {
          font-size: var(--fs-h5);
          padding-bottom: var(--regular-spacing);
        }

        &:not(.p-disabled):focus {
          box-shadow: none;
        }
        .p-tabview-nav-link {
          margin-right: var(--xl-spacing);
        }
      }
      &:not(.p-highlight) {
        .p-tabview-title {
          color: var(--text);
        }
      }
      .p-tabview-nav-link {
        background: var(--transparent) !important;
        margin-right: ${({ isBottomMenu }) =>
          isBottomMenu ? 0 : "var(--xl-spacing)"};
      }
      &.p-highlight {
        .p-tabview-nav-link {
          color: var(--text);
          background: var(--transparent);
          border-bottom: ${({ isBottomMenu }) =>
            isBottomMenu ? "none" : "4px solid var(--primary)"};
          &:not(.p-disabled):focus {
            box-shadow: none;
          }
        }
      }
    }
  }
  ${({ breakpoint }) =>
    `@media ${breakpoint.mobile} {
      .p-tabview-nav-container {
        ul {
          li {
            .p-tabview-title {
              font-size: ${({ isBottomMenu }) =>
                isBottomMenu
                  ? "var(--fs-mini) !important"
                  : "var(--fs-base) !important"};
              font-weight: var(--bold-weight) !important;
            }
          }
        }
      }
      .p-tabview-nav {
        li {
          .p-tabview-nav-link {
            font-size: var(--fs-milli);
            font-weight: var(--semibold-weight);
            line-height: var(--lh-base);
            padding: var(--regular-spacing) 0;
            margin-right: ${({ isBottomMenu }) =>
              isBottomMenu ? 0 : "var(--xl-spacing)"};
          }
        }
      }
      .p-tabview-panels {
        .p-tabview-nav {
          li {
            .p-tabview-nav-link {
              margin-right: var(--xl-spacing);
            }
          }
        }
      }
    }
  `}
`;
const StyledTabPanel = styled(PRTabPanel)(layout, flexbox);

const Tabs = ({ content, activeIndex, ...props }) => {
  return (
    <StyledTabView {...props} breakpoint={breakpoint} activeIndex={activeIndex}>
      {content.map((value, index) => (
        <StyledTabPanel
          key={index}
          header={value.title}
          disabled={value.disable}
          leftIcon={value.icon}
        >
          {value.content}
        </StyledTabPanel>
      ))}
    </StyledTabView>
  );
};

Tabs.propTypes = {
  content: Proptypes.array,
  activeIndex: Proptypes.number,
};

export default Tabs;
